export const ADDITIONAL_INFO = {
  HOURLY_RATE_TITLE: 'Hourly Rate',
  HOURLY_RATE_ERROR: 'Hourly rate is a required field',
  HOURLY_RATE_HELPTEXT:
    "Not sure what to put here? Don't worry, we can change it later",
  DEV_EXPERIENCE_TITLE: 'Years of professional experience as a developer',
  DEV_EXPERIENCE_ERROR: 'Years of experience is a required field',
  CR_EXPERIENCE_TITLE:
    'Years of experience reviewing code for teammates or open source projects',
  CR_EXPERIENCE_ERROR: 'Years reviewing code is a required field',
  REVIEW_DESCRIPTION_TITLE:
    'Any additional experience or expertise worth mentioning? (optional)',
  REVIEW_DESCRIPTION_PLACEHOLDER: `E.g. "I'm a core maintainer of ShellJS..."`,
};
